export default function PHP_pclose() {
  return (
    <div>
      <h1>PHP_pclose</h1>
    </div>
  );
}
